import BoardsView from './components/BoardsView';
import { frontendURL } from '../../../helper/URLHelper';
import { registerCookieLastBoardPage } from '../../../helper/routeHelpers';
import Cookies from 'js-cookie';

export const routes = [
    {
      path: frontendURL('accounts/:accountId/boards'),
      redirect: (to) => {
        const lastBoard = Cookies.get("cx_last_board_page");
        if(lastBoard && lastBoard.trim() != ""){
          return lastBoard;
        }
        return frontendURL('accounts/:accountId/board-teams/status/open');
      }
    },
    {
      path: frontendURL('accounts/:accountId/boards/*'),
      redirect: (to) => {
        return to.fullPath.replace('/boards/', '/board-status/');
      }
    },
    {
      path: frontendURL('accounts/:accountId/board-status'),
      name: 'board_status',
      roles: ['administrator', 'agent', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: BoardsView,
      props: route => ({
        boardType: 'status', 
      }),
      beforeEnter: registerCookieLastBoardPage
    },
    {
      path: frontendURL('accounts/:accountId/board-teams'),
      name: 'board_teams',
      roles: ['administrator', 'agent', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: BoardsView,
      props: route => ({
        boardType: 'teams', 
      }),
      beforeEnter: registerCookieLastBoardPage
    },
    {
      path: frontendURL('accounts/:accountId/board-inboxes'),
      name: 'board_inboxes',
      roles: ['administrator', 'agent', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: BoardsView,
      props: route => ({
        boardType: 'inboxes', 
      }),
      beforeEnter: registerCookieLastBoardPage
    },
    {
      path: frontendURL('accounts/:accountId/board-:boardType/conversations/:conversationId'),
      name: 'board_conversations_through_board_type',
      roles: ['administrator', 'agent', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: BoardsView,
      props: route => ({
        boardType: route.params.boardType,
        conversationId: route.params.conversationId,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/board-:boardType/team/:teamId'),
      name: 'board_filter_team',
      roles: ['administrator', 'agent', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: BoardsView,
      props: route => ({
        teamId: route.params.teamId,
        boardType: route.params.boardType, 
      }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/board-:boardType/team/:teamId/conversations/:conversationId'
      ),
      name: 'board_conversations_through_team',
      roles: ['administrator', 'agent', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: BoardsView,
      props: route => ({
        conversationId: route.params.conversationId,
        teamId: route.params.teamId,
        boardType: route.params.boardType,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/board-:boardType/inbox/:inbox_id'),
      name: 'board_filter_inbox',
      roles: ['administrator', 'agent', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: BoardsView,
      props: route => {
        return { inboxId: route.params.inbox_id, boardType: route.params.boardType };
      },
    },
    {
      path: frontendURL(
        'accounts/:accountId/board-:boardType/inbox/:inbox_id/conversations/:conversation_id'
      ),
      name: 'board_conversation_through_inbox',
      roles: ['administrator', 'agent', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: BoardsView,
      props: route => {
        return {
          conversationId: route.params.conversation_id,
          inboxId: route.params.inbox_id,
          boardType: route.params.boardType,
        };
      },
    },
    {
      path: frontendURL('accounts/:accountId/board-:boardType/label/:label'),
      name: 'board_filter_label',
      roles: ['administrator', 'agent', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: BoardsView,
      props: route => ({ label: route.params.label, boardType: route.params.boardType }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/board-:boardType/label/:label/conversations/:conversation_id'
      ),
      name: 'board_conversations_through_label',
      roles: ['administrator', 'agent', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: BoardsView,
      props: route => ({
        conversationId: route.params.conversation_id,
        label: route.params.label,
        boardType: route.params.boardType,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/board-:boardType/status/:status'),
      name: 'board_filter_status',
      roles: ['administrator', 'agent', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: BoardsView,
      props: route => ({ status: route.params.status, boardType: route.params.boardType }),
      beforeEnter: registerCookieLastBoardPage
    },
    {
      path: frontendURL(
        'accounts/:accountId/board-:boardType/status/:status/conversations/:conversation_id'
      ),
      name: 'board_conversations_through_status',
      roles: ['administrator', 'agent', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
      component: BoardsView,
      props: route => ({
        conversationId: route.params.conversation_id,
        status: route.params.status,
        boardType: route.params.boardType,
      }),
    },
];